var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopNavBar2'),_c('thank1'),_c('Footer1')],1)}
var staticRenderFns = []

export { render, staticRenderFns }